import {
  ADD_MANUALLY_SUFFIX,
  POST_CODE_LIST,
  POSTCODE_ERROR
} from '../../components/Address/addressUtils/addressConstants';
import { SELECTED_ADDRESS } from '../../utils/constants';

export const lookupRegisterDetails = state => state.address.get(POST_CODE_LIST).toJS();

export const isAddManuallyClicked = (state, key, currentIndex) => {
  if (key && state.address) {
    const addressObj = state.address.toJS();
    return addressObj.address && addressObj.address[currentIndex]
      ? addressObj.address[currentIndex][`${key}${ADD_MANUALLY_SUFFIX}`]
      : false;
  }
  return false;
};

export const postCodeAddressList = (state, key, currentIndex) => {
  if (key && state.address) {
    const addressObj = state.address.toJS();
    return addressObj.address && addressObj.address[currentIndex]
      ? filterAddresses(addressObj.address[currentIndex][`${key}${POST_CODE_LIST}`])
      : '';
  }
  return '';
};

export const selectedAddress = (state, key) => {
  const selectedAddress = key ? state.address.get(`${key}${SELECTED_ADDRESS}`) : '';
  return selectedAddress ? selectedAddress.id : '';
};

const filterAddresses = addresses =>
  addresses
    ? addresses.map(address => ({
        id: address.id,
        label: address.potential_address,
        value: address.potential_address
      }))
    : [];

export const noOfAddresses = (state, index) => {
  const addressObj = state.address.toJS();
  return addressObj.address && addressObj.address[index] && addressObj.address[index].addressList
    ? addressObj.address[index].addressList[0]
    : [];
};

export const isPostCodeListError = (state, key, currentIndex) => {
  if (key && state.address) {
    const addressObj = state.address.toJS();
    return addressObj.address && addressObj.address[currentIndex]
      ? addressObj.address[currentIndex][`${key}${POSTCODE_ERROR}`]
      : false;
  }
  return false;
};
